const columnDataGrid = [
  {
    dataField: 'batchId',
    caption: 'Партия SAP',
    dataType: 'string',
    groupIndex: 1
  },
  {
    dataField: 'qcId',
    caption: 'Номер СК',
    dataType: 'string',
    groupIndex: 2
  },
  {
    dataField: 'cgId',
    caption: 'Номер партии',
    dataType: 'string',
    groupIndex: 3
  },
  {
    dataField: 'actualPieceId',
    caption: 'Номер УЕ',
    dataType: 'string',
    groupIndex: 4
  },
  {
    dataField: 'productGroupDescription',
    caption: 'Продукт',
    dataType: 'string',
    groupIndex: 5
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во',
    dataType: 'number',
    groupIndex: 6
  },
  {
    dataField: 'quantityRemain',
    caption: 'Кол-во ост.',
    dataType: 'number',
    groupIndex: 7
  },
  {
    dataField: 'unitShort',
    caption: 'ЕИ',
    dataType: 'string',
    groupIndex: 8
  },
  {
    dataField: 'percentWasteMaterial',
    caption: '% отходов',
    dataType: 'number',
    groupIndex: 9
  },
  {
    dataField: 'weightCurrent',
    caption: 'Кол-во текущее',
    dataType: 'number',
    groupIndex: 10
  },
  {
    dataField: 'weightWasteMaterialCurrent',
    caption: 'Кол-во всех отходов, текущее',
    notVisible: true,
    dataType: 'number',
    groupIndex: 11
  },
  {
    dataField: 'weightOff',
    caption: 'Кол-во списания',
    dataType: 'number',
    groupIndex: 12
  },
  {
    dataField: 'pieceNumId',
    caption: 'Ключ УЕ ПФ',
    notVisible: true,
    dataType: 'integer',
    groupIndex: 13
  }
];

export default columnDataGrid;
